import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var SeoSensitiveTermsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query sensitiveTerm($term: String! = \"\") {\n    sensitiveTerm(term: $term) {\n      term\n      title\n      setNoIndex\n      adjustTitle\n    }\n  }\n"])));
export default SeoSensitiveTermsQuery;